export default __webpack_public_path__ + "static/media/document-icon.9f8a382e.jpg";